import React, { useState, useEffect, FC } from 'react'

import SelectLang from '@components/SelectLang'
import SelectProfile, { Profile } from '@components/SelectProfile'
import { SHOW, HIDE, trans } from '@helpers/translator'
import LogoVisitMonaco from '@images/logo_visitmonaco.svg?react'

export interface Language {
  code: string
  label: string
  url: string
  selected?: boolean
}

interface HeaderProps {
  profiles: Profile[]
  languages: Language[]
  homeUrl: string
}

const Header: FC<HeaderProps> = ({ profiles, languages, homeUrl }) => {
  const [hideHeader, setHideHeader] = useState(false)
  const [isEditorialMode, setIsEditorialMode] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    // @ts-ignore
    setIsEditorialMode(window.parent?.eZ?.pageBuilder?.config?.mode === 'edit')
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      setIsScrolled(scrollTop > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      {isEditorialMode && (
        <button
          onClick={() => setHideHeader(!hideHeader)}
          className="fixed top-0 left-0 z-[9999] bg-blue text-white p-2 m-2 rounded"
        >
          {hideHeader ? trans(SHOW) : trans(HIDE)}
        </button>
      )}
      {!hideHeader && (
        <header className="ltr:md:pl-sidebar-desktop ltr:pl-sidebar-mobile rtl:md:pr-sidebar-desktop rtl:pr-sidebar-mobile fixed top-0  w-[calc(100%-theme(spacing.sidebar-mobile))] md:w-full z-[1000] pointer-events-none ">
          <div
            className={`flex md:justify-end justify-between items-center md:backdrop-blur-none -mx-[51px] pl-[51px] md:pl-0 md:mx-0 ${isScrolled ? 'backdrop-blur-[10px] ' : ''}`}
          >
            <div className="md:hidden" aria-hidden="true">
              <a
                href={homeUrl}
                className={`pointer-events-auto transition-all duration-300`}
              >
                <LogoVisitMonaco
                  className={`w-[96px] text-black sidebar-elmt transition-colors duration-400 ml-4`}
                  aria-label="Visit Monaco"
                />
              </a>
            </div>
            <SelectProfile
              className="pointer-events-auto"
              profiles={profiles}
            />
            <SelectLang
              className="hidden md:block pointer-events-auto"
              languages={languages}
            />
          </div>
        </header>
      )}
    </>
  )
}

export default Header
